/* src/app/shared-components/add-edit-collaborators/add-edit-collaborators.component.scss */
.user-img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  margin-right: 1rem;
}
/*# sourceMappingURL=add-edit-collaborators.component.css.map */
